import graphql from './graphql';

const query = /* GraphQL */ `
  query User_Authors {
    User_Authors {
      fullName
    }
  }
`;

const UserAuthors = async () =>
  graphql(query).then(
    // eslint-disable-next-line camelcase
    ({ User_Authors }) => User_Authors
  );

export default UserAuthors;
